module.exports = __webpack_public_path__ + "static/media/checked-black.3b924f6f.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/checked-black.svg
 ** module id = 1265
 ** module chunks = 0
 **/